///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';
import { GtthRefreshTopologyCommand } from './refresh-topology-command';
import { AttachedFileDTO, GtthStepGroupEnum } from '../../../../../generated/shared-types.model';
import { GtthUpdateMainConfigCommand } from './update-main-config-command';

export class GtthImportTopologyCommand extends GtthAbstractCommand {
    private attachedFile: AttachedFileDTO;

    private importResult: ActivityDTO;

    getCommandName(): string {
        return 'GtthImportTopologyCommand';
    }

    create(importFile: AttachedFileDTO): this {
        this.attachedFile = importFile;
        return this;
    }

    protected doCommand(): void {
        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.show('Loading')
        });

        this.historyService.doCommandBypassHistory(this.historyService.command(GtthUpdateMainConfigCommand)).then((_result: boolean) => {
            const importActivity = this.createActivityDTO(false);
            importActivity.attachedFile = this.attachedFile;
            this.sendActivity(importActivity);
        });
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        this.importResult = activityDto;

        if (activityDto?.error?.message) {
            this.historyService.notificationService.showError(activityDto.error.message);
        }

        if (!activityDto.successful) {
            if (this.commandResolve) {
                this.historyService.eventManager.broadcast({
                    name: 'togglePreloaderModal',
                    eventObject: GtthPreloaderModalEvent.hide()
                });

                this.commandResolve(false);
            }
            return;
        }

        this.historyService.clearHistory();

        const refreshCommand = this.historyService.command(GtthRefreshTopologyCommand).create(false, true);
        this.historyService.doCommandBypassHistory(refreshCommand).then((refreshResult: boolean) => {
            if (this.commandResolve) {
                this.historyService.bomReportService.clearBom();
                this.historyService.logicalTopology.clearNodeNamesSectorsToShow();
                this.historyService.projectProductsService.loadProducts(this.project.id, true).then(() => {
                    if (activityDto.enableBasicReports) {
                        this.historyService.logicalTopology
                            .setShowPlanningMode(this.historyService, true, true, true)
                            .then((_result: any) => {
                                this.historyService.eventManager.broadcast({
                                    name: 'changeProjectStep',
                                    stepNumber: GtthStepGroupEnum.PLAN_AND_OPTIMISE
                                });
                                this.commandResolve(refreshResult);
                            });
                    } else {
                        this.commandResolve(refreshResult);
                    }
                });
            }
        });
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        if (this.importResult) {
            return !this.importResult.enableBasicReports;
        } else {
            return true;
        }
    }
}
